// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"styles_buttonsContainer__mwFWB","activeButton":"styles_activeButton__nQbOS","tab":"styles_tab__1TCP5","active":"styles_active__AwAvn"};